import { render, staticRenderFns } from "./OxygenDisplayValue.vue?vue&type=template&id=0e65761e&"
import script from "./OxygenDisplayValue.vue?vue&type=script&lang=ts&"
export * from "./OxygenDisplayValue.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenDisplayValue.vue?vue&type=style&index=0&id=0e65761e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports